import {
  CreateDealPrice,
  IAllocatePriceParams,
  ICheckEcodeSerialParams,
  ICreateBILLING,
  ICreateEInvoice,
  IGetAllConditionTypeParams,
  IGetAllocatePriceSAP,
  IGetOrderParams,
  IGetOrderProcessParams,
  IGetOrderTempByIdParams,
  IGetStatusOrder,
  IMergeOrderParams,
  IPostDataParams,
  IPrintFile,
  IUpdateOrderTempParams,
} from 'interfaces/SalesInfo';
import axiosGraphQL from './GraphQL/axiosGraphQL';
import { SALES_INFO_QUERIES } from './GraphQL/Queries/salesInfoQuery';
import { SALES_INFO_VARIABLES } from './GraphQL/Variables/salesInfo';
import axiosClient from './setup/axiosClient';
import { log } from 'console';

export type TAllocateUpdateJsonParams = IAllocatePriceParams & {
  successMessage?: string;
  isRefetch?: boolean;
  type?: 'init' | 'updatedCustomer' | 'allocatePriceFailure';
  afterMutateSuccess?: () => void;
};

export const SalesInfoApis = {
  getGoldSoldBuyOrder: async (orderId: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: SALES_INFO_QUERIES.GET_GOLD_SOLD_BUY_ORDER,
      variables: SALES_INFO_VARIABLES.getGoldSoldBuyOrder(orderId),
    });
  },
  getCustomer: async (customerId: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: SALES_INFO_QUERIES.GET_CUSTOMER,
      variables: SALES_INFO_VARIABLES.getCustomer(customerId),
    });
  },
  getOrder: async (params: IGetOrderParams) => {
    return await axiosGraphQL.post('/graphql', {
      query: SALES_INFO_QUERIES.GET_ORDER,
      variables: SALES_INFO_VARIABLES.getOrder(params),
    });
  },
  getPromotionData: async (orderId: string) => {
    return await axiosClient.post(
      `${process.env.REACT_APP_API_BASE_URL}/sap/allocate-get-json`,
      {
        orderId,
      },
    );
  },
  allocatePrice: async (params: IAllocatePriceParams) => {
    return await axiosClient.post(
      `${process.env.REACT_APP_API_BASE_URL}/sap/allocate-price`,
      {
        ...params,
        ConditionDelete: params?.ConditionDelete ?? { results: [] },
        ConditionInsert: params?.ConditionInsert ?? { results: [] },
        Item: {
          results: (params?.Item?.results ?? []).reduce((acc: any, item) => {
            const { TextScan, ProcessPriceSAP, ProcessPrice, ...others } = item;
            acc.push(others);

            return acc;
          }, []),
        },
        PromoHeader: {
          results: (params?.PromoHeader?.results ?? []).map((item) => ({
            Key: item?.Key,
            SaleDeal: item?.SaleDeal,
            ConditionType: item?.ConditionType,
            ConditionValue: item?.ConditionValue,
          })),
        },
        Voucher: {
          results: (params?.Voucher?.results ?? []).map((item) => ({
            ConditionType: item?.ConditionType,
            Item: item?.Item,
            Key: item?.Key,
            SaleDeal: item?.SaleDeal,
            Serial: item?.Serial,
            Voucher: item?.Voucher,
          })),
        },
        PromoItem: {
          results: (params?.PromoItem?.results ?? []).map((item) => ({
            Key: item?.Key,
            Item: item?.Item,
            Material: item?.Material,
            SaleDeal: item?.SaleDeal,
            ConditionType: item?.ConditionType,
            ConditionValue: item?.ConditionValue,
          })),
        },
        OutputHeader: {
          results: [],
        },
        OutputItem: {
          results: [],
        },
        OutputDiscount: {
          results: [],
        },
        Return: {
          results: [],
        },
      } as IAllocatePriceParams,
    );
  },
  checkEcodeSerial: async (params: ICheckEcodeSerialParams) => {
    return await axiosClient.post(
      `${process.env.REACT_APP_API_BASE_URL}/sap/check_ecode_serial`,
      {
        ...params,
        Option: 'H',
        Output: {
          results: [],
        },
        Status: {
          results: [],
        },
      },
    );
  },
  allocateUpdateJson: async (params: TAllocateUpdateJsonParams) => {
    const { successMessage, isRefetch, afterMutateSuccess, ...others } = params;

    return await axiosClient.patch(
      `${process.env.REACT_APP_API_BASE_URL}/sap/allocate-update-json`,
      {
        orderId: params?.Key,
        metadata: others,
      },
    );
  },

  resetOrder: async (params: any) => {
    return await axiosClient.post(
      `${process.env.REACT_APP_API_BASE_URL}/sap/reset-order`,
      {
        orderId: params,
      },
    );
  },

  getAllConditionTypes: async (params: IGetAllConditionTypeParams) => {
    return await axiosGraphQL.post('/graphql', {
      query: SALES_INFO_QUERIES.GET_ALL_CONDITION_TYPES,
      variables: SALES_INFO_VARIABLES.getAllConditionTypes(params),
    });
  },
  getSaleDeals: async (orderId: string) => {
    return await axiosClient.post(
      `${process.env.REACT_APP_API_BASE_URL}/sap/get-sale-deal`,
      { orderId },
    );
  },
  getOrderProcess: async (params: IGetOrderProcessParams) => {
    return await axiosGraphQL.post('/graphql', {
      query: SALES_INFO_QUERIES.GET_SAP_ORDER_PROCESS,
      variables: SALES_INFO_VARIABLES.getOrderProcess(params),
    });
  },
  getCustomerList: async (customerId: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: SALES_INFO_QUERIES.GET_CUSTOMER_LIST,
      variables: SALES_INFO_VARIABLES.getCustomerList(customerId),
    });
  },
  updateOrderTemp: async (params: IUpdateOrderTempParams) => {
    return await axiosGraphQL.post('/graphql', {
      query: SALES_INFO_QUERIES.UPDATE_ORDER_TEMP,
      variables: SALES_INFO_VARIABLES.updateOrderTemp(params),
    });
  },
  createOrder: async (params: IAllocatePriceParams) => {
    return await axiosClient.post(
      `${process.env.REACT_APP_API_BASE_URL}/sap/create-order`,
      {
        ...params,
        ConditionDelete: params?.ConditionDelete ?? { results: [] },
        ConditionInsert: params?.ConditionInsert ?? { results: [] },
        Item: {
          results: (params?.Item?.results ?? []).reduce((acc: any, item) => {
            const { TextScan, ProcessPriceSAP, ProcessPrice, ...others } = item;
            acc.push(others);

            return acc;
          }, []),
        },
        PromoHeader: {
          results: (params?.PromoHeader?.results ?? []).map((item) => ({
            Key: item?.Key,
            SaleDeal: item?.SaleDeal,
            ConditionType: item?.ConditionType,
            ConditionValue: item?.ConditionValue,
          })),
        },
        Voucher: {
          results: (params?.Voucher?.results ?? []).map((item) => ({
            ConditionType: item?.ConditionType,
            Item: item?.Item,
            Key: item?.Key,
            SaleDeal: item?.SaleDeal,
            Serial: item?.Serial,
            Voucher: item?.Voucher,
          })),
        },
        PromoItem: {
          results: (params?.PromoItem?.results ?? []).map((item) => ({
            Key: item?.Key,
            Item: item?.Item,
            Material: item?.Material,
            SaleDeal: item?.SaleDeal,
            ConditionType: item?.ConditionType,
            ConditionValue: item?.ConditionValue,
          })),
        },
        OutputHeader: {
          results: [],
        },
      } as IAllocatePriceParams,
    );
  },
  getOrderTempById: async (params: IGetOrderTempByIdParams) => {
    return await axiosGraphQL.post('/graphql', {
      query: SALES_INFO_QUERIES.GET_ORDER_TEMP,
      variables: SALES_INFO_VARIABLES.getOrderTempById(params),
    });
  },
  mergeOrder: async (params: IMergeOrderParams) => {
    const { orderIds, productIds } = params;

    return await axiosClient.post(
      `${process.env.REACT_APP_API_BASE_URL}/sap/merge-order`,
      {
        orderIds,
        ...(productIds && { productIds: productIds }),
      } as IMergeOrderParams,
    );
  },
  cancelMergeOrder: async (params: { orderId: string }) => {
    return await axiosClient.post(
      `${process.env.REACT_APP_API_BASE_URL}/sap/cancel-merge-order`,
      params,
    );
  },
  allocatePriceSap: async (params: IGetAllocatePriceSAP) => {
    return await axiosClient.post(
      `${process.env.REACT_APP_API_BASE_URL}/sap/allocate-price-sap`,
      params,
    );
  },
  postData: async (params: IPostDataParams) => {
    return await axiosClient.post(
      `${process.env.REACT_APP_API_BASE_URL}/lambda/postData?token=token`,
      {
        name: 'allocate-order',
        data: `{"REFCODE":"${params.REFCODE}","MODULE":"SM","DESCRIPTION":"SIMULATE THàNH CôNG","CODE":"S","VALUE":"${params.VALUE}"}`,
      },
      { headers: { 'x-api-key': 's7eAcEOcggNU7k7KdZa3XxWgjZ4QG5X3' } },
    );
  },
  printFile: async (params: IPrintFile) => {
    return axiosClient.post(
      `${process.env.REACT_APP_API_BASE_URL}/print/print${
        params.type === 'pdf' || params.type === 'print' ? 'Pdf' : 'Excel'
      }`,
      {
        printFunctionId:
          params.orderTypeId === 'A109_01'
            ? params.isMon
              ? 'pr10000005'
              : 'pr10000002'
            : 'pr10000001',
        // printFunctionId:
        //   params.type === 'pdf' || params.type === 'print'
        //     ? params.orderTypeId === 'A109_01'
        //       ? 'pr10000002'
        //       : 'pr10000001'
        //     : 'pr10000002',
        params: [
          {
            key: 'orderid',
            value: params.orderId,
          },
        ],
        orientation: 'portrait',
        pageSize: 'A4',
      },
      {
        responseType: 'blob',
      },
    );
  },
  getOrderDealPrice: async (orderId: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: SALES_INFO_QUERIES.GET_ORDER_DEAL_PRICE,
      variables: SALES_INFO_VARIABLES.getOrderDealPrice(orderId),
    });
  },

  createBilling: async (params: ICreateBILLING) => {
    return axiosClient.post(
      `${process.env.REACT_APP_API_BASE_URL}/sap/create-bill`,
      {
        Key: params.Key,
        Delivery: params.Delivery,
        GoodIssue: params.GoodIssue,
        Year: params.Year,
        Output: {
          results: [],
        },
        Return: {
          results: [],
        },
      },
    );
  },
  createEInvoice: async (params: ICreateEInvoice) => {
    return axiosClient.post(
      `${process.env.REACT_APP_API_BASE_URL}/sap/create-einvoice/${params.orderId}`,
      {
        PVBELN: params.PVBELN,
        IV_NAME: 'MDMS',
        IV_UNAME: 'MDMS',
      },
    );
  },
  cancelSAPDocument: async (orderId: string) => {
    return axiosClient.post(
      `${process.env.REACT_APP_API_BASE_URL}/sap/cancel-order`,
      { orderId },
    );
  },
  getGoldSoldYBuyOrder: async (orderId: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: SALES_INFO_QUERIES.GET_GOLD_SOLD_Y_BY_ORDER,
      variables: SALES_INFO_VARIABLES.getGoldSoldBuyOrder(orderId),
    });
  },
  getOrderStatusComboBox: async (params: IGetStatusOrder) => {
    return await axiosGraphQL.post('/graphql', {
      query: SALES_INFO_QUERIES.GET_ORDER_STATUS_COMBOBOX,
      variables: SALES_INFO_VARIABLES.getOrderStatusComboBox(params),
    });
  },
  printEInvoice: async (orderId: string) => {
    return axiosClient.post(
      `${process.env.REACT_APP_API_BASE_URL}/sap/sap-order-info`,
      { orderId },
    );
  },
  reSendOrderToSAP: (orderId: string) => {
    return axiosClient.post(
      `${process.env.REACT_APP_API_BASE_URL}/sap/retry-order`,
      { orderId },
    );
  },
  createDealPrice: async (params: CreateDealPrice) => {
    return await axiosGraphQL.post('/graphql', {
      query: SALES_INFO_QUERIES.CREATE_DEAL_PRICE,
      variables: SALES_INFO_VARIABLES.createDealPrice(params),
    });
  },
};
